<template>
<div>
  <div class="popBg" @click="closeSelectAddress"></div>

  <div class="popup fixed">
    <div class="popup__inner fixed z-40 py-4 px-4 md bg-white max-w-2xl rounded">
      <div class="popup__header text-NotoSansRegular text-sm mb-2 underline flex justify-between">
        <span>常用通訊錄</span>
        <a @click="closeSelectAddress" class="cursor-pointer">
          <font-awesome-icon icon="times" />關閉
        </a>
      </div>
      <div class="popup__body text-NotoSansRegular w-full flex flex-col justify-between" style="min-height: 15rem;">
        <div v-if="addressList">
          <div v-for="(item, index) in addressList" :key="index">
            <div class="w-full flex border-b border-gray-400 bg-white text-xs items-center py-2 justify-between">
              <div class="flex">
                <div class="flex justify-end items-center mr-2 md:mr-1">
                  <button @click="selectedAdd(item)" class="whitespace-no-wrap text-xs border border-gray-500 hover:border-gray-700 text-gray-500 hover:text-gray-700 py-1 px-3 rounded focus:outline-none cursor-pointer">
                    使用
                  </button>
                </div>
                <div class="w-full">
                  <ul class="md:flex items-center">
                    <li class="leading-loose md:mr-2">{{ item.name }}<label v-if="item.is_preset === 1" class="ml-2 mb-0 px-2 py-1 bgLiveABCRed rounded-full text-white text-xs md:hidden">預設</label></li>
                    <li class="leading-loose md:mr-2">{{ item.mobile ? item.mobile : '' }}&emsp;{{ item.tel ? item.tel : '' }}</li>
                    <li class="leading-loose">{{ item.city }}{{ item.district }}{{ item.address }}<label v-if="item.is_preset === 1" class="ml-2 mb-0 px-2 py-1 bgLiveABCRed rounded-full text-white text-xs hidden md:inline">預設</label></li>
                  </ul>
                </div>
              </div>
              <a class="px-2 py-1 cursor-pointer" @click="deleteItem(item.id)" v-if="item.is_preset === 0">
                <font-awesome-icon icon="times" />
              </a>
            </div>
          </div>
        </div>
        <div v-else>
          <img src="~@/assets/icon/Pulse.gif" class="mx-auto h-12">
        </div>

        <PaginateComponent v-if="addressList" :pagination="pagination" v-on:pageChangeHandler="pageChangeHandler" />

      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import PaginateComponent from '@/components/modules/Paginatation'
export default {
  name: 'SelectAddressList',

  data () {
    return {
      addressList: null,

      pageSize: 10,

      // pagination
      pagination: {
        currentPage: 1,
        length: 1
      },

      isAdding: false,

      name: null,
      mobile: null,
      tel: null,
      city: null,
      district: null,
      zip_code: null,
      address: null
    }
  },

  components: {
    PaginateComponent
  },
  computed: {
    ...mapGetters([
      'authorized',
      'user'
    ])
  },
  mounted () {
    this.getList()
  },
  methods: {
    closeSelectAddress () {
      let self = this
      self.$emit('closeSelectAddress', false)
    },
    getList () {
      let self = this
      axios.get(`/user/recipients?page=${self.pagination.currentPage}&pageSize=${self.pageSize}&user_id=${self.user.id}`)
        .then((response) => {
          self.addressList = response.data.data
          self.pagination.length = response.data.last_page
        })
    },
    selectedAdd (item) {
      let self = this
      self.closeSelectAddress()
      self.$emit('selectedAdd', item)
    },
    async pageChangeHandler (pageChangeHandler) {
      let self = this
      self.pagination.currentPage = pageChangeHandler

      self.getList()
    },
    async deleteItem (id) {
      let self = this
      await axios.delete(`/user/recipients/${id}`)
        .then((response) => {
          self.getList()
        })

      if (self.addressList.length === 1) {
        self.pagination.currentPage = 1
        self.getList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.popBg {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed !important;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.popup {
  z-index: 1000;
  .popup__inner {
    top: 20%;
    left: 0;
    right: 0;
    margin: 0 auto;
    line-height: 1.5;
    letter-spacing: .05em;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    -webkit-transform: scale(0.3);
    -moz-transform: scale(0.3);
    -ms-transform: scale(0.3);
    -o-transform: scale(0.3);
    transform: scale(0.3);

    -webkit-animation-name: example;
    -webkit-animation-duration: .4s;
    animation-name: example;
    animation-duration: .4s;
    animation-fill-mode: forwards;
    .popup__header {
      margin-bottom: 15px;
      font-size: 0.85em;
      font-weight: bold;
    }
    .popup__body {
      font-size: 0.85em;
    }
    .popup__buttons {
          text-align: right;
      .btn--small {
          line-height: 22px;
      }
      .btn {
        display: inline-block;
        font-size: 11px;
        text-align: center;
        text-decoration: none;
        vertical-align: middle;
        height: auto;
        line-height: 1;
        background-color: white;
        border: 1px solid #9c9c9c;
        color: #434343;
        white-space: nowrap;
        transition: .3s;
        border-radius: 5px;
        &:hover {
          border: 1px solid #a0a0a0;
          background: #9c9c9c !important;
          color: white;
        }
      }
    }
  }
@media (min-width: 768px) {
  .popup__inner {
    top: 25%;
  }
}
}
@-webkit-keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}

/* Standard syntax */
@keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}
</style>
